/// \file SecurityLockouts.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2024 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import {lazy, Suspense} from "react";
import { ActionFunctionArgs, LoaderFunctionArgs, Route } from "react-router-dom";

const SecurityLockoutsList = lazy(() => import('../views/security-lockouts/list/view'));

async function SecurityLockoutsDataLoader(args: LoaderFunctionArgs) {
  const actualLoader = (await import('../views/security-lockouts/list/loader')).default;
  return actualLoader(args);
}

export async function SecurityLockoutsAction(args: ActionFunctionArgs) {
  const actualAction = (await import("../views/security-lockouts/list/action")).action;
  return actualAction(args);
}

const routes = (
  <Route
    path="SecurityLockouts"
    handle={{
      text: 'Security Lockouts'
      }}
  >
    <Route 
      index
      element={
        <Suspense fallback={<div>Loading...</div>}>
          <SecurityLockoutsList />
        </Suspense>
      }     
      loader={SecurityLockoutsDataLoader}
      action={SecurityLockoutsAction}
      />
  </Route>
);

export default routes;